module.exports = __webpack_public_path__ + "resources/img/img_goldilocks2_m.4ab6e6306db21dcf4051305d107269b5.png";